import { Box, Container, VStack, Image } from "@chakra-ui/react";
import { Button, Heading, Paragraph } from "mainstack-design-system";
import errorImage from "../assets/image/notFound.svg";
import { useNavigate } from "react-router-dom";

interface NotFoundProps {
  error?: Error;
}

export default function NotFound({ error }: NotFoundProps) {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/dashboard");
  };

  return (
    <Box bg="white" minH="100svh">
      <Container size="xxl" maxW="1192px">
        <VStack>
          <VStack
            as="main"
            data-testid="error"
            p={5}
            textAlign="center"
            flexGrow={1}
            width="100%"
            justifyContent="center"
            minH="85svh"
          >
            <Image src={errorImage} alt="" display="inline-block" />

            <Heading size="3xs" color="black">
              Oops!
            </Heading>

            <Paragraph size="xxs" marginTop={24} fontWeight={600}>
              {error
                ? error.message
                : `The page you're looking for could not be found.`}
            </Paragraph>

            <Button
              variant="primary"
              size="small"
              label="Go back to Homepage"
              marginTop={40}
              onClick={goHome}
            />
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
}
